import React from "react";
import Head from 'next/head';
import _ from 'lodash';

interface SEOContentProps {
  pageTitle?: string;
  seoContent?: any;
}

export const SEOContent: React.FC<SEOContentProps> = ({pageTitle, seoContent}) => {
  const meta: any = seoContent.meta;
  const keywords = _.split(_.get(_.find(meta, {name: 'keywords'}), 'content'), ', ');
  const data: any = seoContent.data;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        {meta.map((item: any) => (
          <meta
            name={item.name}
            content={item.content}
          />
        ))}

        {/* Structured Data for Search Engines */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(data)
          }}
        />
      </Head>

      {/* Screen-reader + SEO-friendly hidden content */}
      <div className="sr-only">
        <h1>{pageTitle}</h1>
        <p>{data.description}</p>
        <ul>
          {keywords.map((item) => (
            <li>{item}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default SEOContent;
